import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { db } from "../firebase"; // Firebase setup
import { collection, getDocs } from "firebase/firestore";

// Register the required components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const IndProgressChart = () => {
  const [chartData, setChartData] = useState(null);

  const fetchProgressData = async () => {
    const dailyTaskCollection = collection(db, "dailyTasks");
    const snapshot = await getDocs(dailyTaskCollection);
    const data = {};

    snapshot.forEach((doc) => {
      const { subtasks } = doc.data();
      subtasks.forEach((task) => {
        if (!data[task.name]) {
          data[task.name] = [];
        }
        const completed = task.completed ? 1 : 0;
        data[task.name].push({ date: doc.id, completed });
      });
    });

    // Get unique dates and sort them
    const allDates = Object.values(data)
      .flat()
      .map((entry) => entry.date);
    const uniqueDates = [...new Set(allDates)].sort(
      (a, b) => new Date(a) - new Date(b)
    );

    const datasets = Object.keys(data).map((taskName, index) => {
      const colorPalette = [
        "#FF6384", // Red
        "#36A2EB", // Blue
        "#FFCE56", // Yellow
        "#4CAF50", // Green
        "#9966FF", // Purple
        "#FF9F40", // Orange
      ];

      // Ensure all task data align to the unique dates
      const completedCounts = uniqueDates.map((date) => {
        const taskForDate = data[taskName].find((entry) => entry.date === date);
        return taskForDate ? taskForDate.completed : 0;
      });

      return {
        label: taskName,
        data: completedCounts,
        borderColor: colorPalette[index % colorPalette.length],
        backgroundColor: `${colorPalette[index % colorPalette.length]}33`, // Lighter version
        fill: false,
        tension: 0.4,
      };
    });

    setChartData({
      labels: uniqueDates,
      datasets,
    });
  };

  useEffect(() => {
    fetchProgressData();
  }, []);

  return (
    <Container>
      <h2>Progress Chart (Main Tasks)</h2>
      {chartData ? (
        <Line
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                display: true,
                position: "top",
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: "Dates",
                },
              },
              y: {
                title: {
                  display: true,
                  text: "Tasks Completed",
                },
                beginAtZero: true,
              },
            },
          }}
        />
      ) : (
        <p>Loading chart...</p>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 36%;
  padding: 30px;
  max-width: 800px;
  max-height: 550px;
  background-color: #171c29;
  color: white;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  h2 {
    font-weight: 300;
    text-align: center;
    margin-bottom: 20px;
  }
  /* @media (max-width: 500px) {
    width: 100%;
    min-width: 100px;
    max-height: 650px;
  } */
  @media (max-width: 1420px) {
    width: 47%;
  }
  @media (max-width: 1100px) {
    width: 100%;
    max-width: 5000px;
  }
`;

export default IndProgressChart;
